var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDinersClub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 22,
    viewBox: "0 0 32 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.89543 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V20C32 21.1046 31.1046 22 30 22H2C0.895431 22 0 21.1046 0 20V2Z",
    fill: "#0079BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7167 18.8367C22.0473 18.8574 26 15.3067 26 10.9872C26 6.26349 22.0473 2.99843 17.7167 3H13.9897C9.60721 2.99843 6 6.26446 6 10.9872C6 15.3076 9.60721 18.8574 13.9897 18.8367H17.7167Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0077 3.65524C10.0031 3.6565 6.75802 6.90082 6.75708 10.905C6.75802 14.9084 10.003 18.1524 14.0077 18.1537C18.0132 18.1524 21.2589 14.9084 21.2595 10.905C21.2589 6.90082 18.0132 3.6565 14.0077 3.65524ZM9.41172 10.905C9.41549 8.94831 10.6381 7.2798 12.3622 6.61676V15.1921C10.6381 14.5295 9.41546 12.8619 9.41172 10.905ZM15.6525 15.194V6.61648C17.3772 7.27791 18.6017 8.94736 18.6049 10.905C18.6017 12.8631 17.3772 14.5313 15.6525 15.194Z",
    fill: "#0079BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0.25H30V-0.25H2V0.25ZM31.75 2V20H32.25V2H31.75ZM30 21.75H2V22.25H30V21.75ZM0.25 20V2H-0.25V20H0.25ZM2 21.75C1.0335 21.75 0.25 20.9665 0.25 20H-0.25C-0.25 21.2426 0.757359 22.25 2 22.25V21.75ZM31.75 20C31.75 20.9665 30.9665 21.75 30 21.75V22.25C31.2426 22.25 32.25 21.2426 32.25 20H31.75ZM30 0.25C30.9665 0.25 31.75 1.0335 31.75 2H32.25C32.25 0.757359 31.2426 -0.25 30 -0.25V0.25ZM2 -0.25C0.757359 -0.25 -0.25 0.757359 -0.25 2H0.25C0.25 1.0335 1.0335 0.25 2 0.25V-0.25Z",
    fill: "#CCCCCC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "static/media/diners-club.a33911b10b9c7c40aff1a8c06cb9e360.svg";
export { ForwardRef as ReactComponent };